"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonSignificantControl$ = exports.PersonSignificantControl$outboundSchema = exports.PersonSignificantControl$inboundSchema = void 0;
exports.personSignificantControlToJSON = personSignificantControlToJSON;
exports.personSignificantControlFromJSON = personSignificantControlFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const pscaddress_js_1 = require("./pscaddress.js");
const pscdateofbirth_js_1 = require("./pscdateofbirth.js");
const psckind_js_1 = require("./psckind.js");
const pscname_js_1 = require("./pscname.js");
const pscnaturesofcontrol_js_1 = require("./pscnaturesofcontrol.js");
/** @internal */
exports.PersonSignificantControl$inboundSchema = z.object({
    company_number: z.string(),
    controls_company_number: z.nullable(z.string()),
    correspondence_address: z.nullable(pscaddress_js_1.PSCAddress$inboundSchema),
    date_of_birth: z.nullable(pscdateofbirth_js_1.PSCDateOfBirth$inboundSchema),
    kind: psckind_js_1.PSCKind$inboundSchema,
    name: z.nullable(pscname_js_1.PSCName$inboundSchema),
    nationality: z.nullable(z.string()),
    natures_of_control: z.nullable(z.array(pscnaturesofcontrol_js_1.PSCNaturesOfControl$inboundSchema)),
    person_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_number": "companyNumber",
        "controls_company_number": "controlsCompanyNumber",
        "correspondence_address": "correspondenceAddress",
        "date_of_birth": "dateOfBirth",
        "natures_of_control": "naturesOfControl",
        "person_id": "personId",
    });
});
/** @internal */
exports.PersonSignificantControl$outboundSchema = z.object({
    companyNumber: z.string(),
    controlsCompanyNumber: z.nullable(z.string()),
    correspondenceAddress: z.nullable(pscaddress_js_1.PSCAddress$outboundSchema),
    dateOfBirth: z.nullable(pscdateofbirth_js_1.PSCDateOfBirth$outboundSchema),
    kind: psckind_js_1.PSCKind$outboundSchema,
    name: z.nullable(pscname_js_1.PSCName$outboundSchema),
    nationality: z.nullable(z.string()),
    naturesOfControl: z.nullable(z.array(pscnaturesofcontrol_js_1.PSCNaturesOfControl$outboundSchema)),
    personId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyNumber: "company_number",
        controlsCompanyNumber: "controls_company_number",
        correspondenceAddress: "correspondence_address",
        dateOfBirth: "date_of_birth",
        naturesOfControl: "natures_of_control",
        personId: "person_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PersonSignificantControl$;
(function (PersonSignificantControl$) {
    /** @deprecated use `PersonSignificantControl$inboundSchema` instead. */
    PersonSignificantControl$.inboundSchema = exports.PersonSignificantControl$inboundSchema;
    /** @deprecated use `PersonSignificantControl$outboundSchema` instead. */
    PersonSignificantControl$.outboundSchema = exports.PersonSignificantControl$outboundSchema;
})(PersonSignificantControl$ || (exports.PersonSignificantControl$ = PersonSignificantControl$ = {}));
function personSignificantControlToJSON(personSignificantControl) {
    return JSON.stringify(exports.PersonSignificantControl$outboundSchema.parse(personSignificantControl));
}
function personSignificantControlFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PersonSignificantControl$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PersonSignificantControl' from JSON`);
}
//# sourceMappingURL=personsignificantcontrol.js.map